import { DetailContainer } from './components/containers/DetailContainer';

const BatchDetail = () => <DetailContainer />;

export default BatchDetail;
